module.exports = __webpack_public_path__ + "img/pantalla-7-4.59718331.png";